import Component from '@glimmer/component';
import RouteTemplate from 'ember-route-template';
import EsportsBanner from '../../components/layout/banner/esports';
import LiveNewsTicker from '../../components/layout/live-news-ticker';
import EsportsNewsComponent from '../../components/layout/news/esports-news';
import EsportsMatchResultsBanner from '../../components/layout/banner/esports-match-results';

class EsportsIndexComponent extends Component {
  <template>
    <EsportsBanner />
    <LiveNewsTicker />
    <EsportsMatchResultsBanner />
    <EsportsNewsComponent @articles={{@model.articles}} @popularPosts={{@model.popularPosts}} />
  </template>
}

export default RouteTemplate(EsportsIndexComponent);
